import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  formBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    width: '100%',
    margin: '2rem 0',
  },

  itemBox: {
    '& span': {
      margin: '0.25rem !important',
    },
  },

  colorBox: {
    width: '100%',
    height: '200px',
    marginTop: '1rem',
    marginBottom: '0.25rem',
    borderRadius: '0.75rem',
  },

  logoBox: {
    width: '100%',
    height: '250px',
    objectFit: 'cover',
  },
}))

export { useStyles }
